import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

/** Public site endpoints — no auth, no session cookie. */
export const publicService = {
  submitInquiry: async (payload) => {
    const { data } = await axios.post(`${API_BASE_URL}/public/enquiries`, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return data;
  },
};

export default publicService;
